import { gql } from '@apollo/client';

export const GET_CRM_NOTIFICATIONS = gql`
  query getCrmNotifications($filter: CrmNotificationFilter)
  @api(name: treatmentMonitor) {
    getCrmNotifications(filter: $filter) {
      notifications {
        id
        type
        userId
        isRead
        relatedId
        relatedType
        relatedName
        data
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

export const MARK_ALL_CRM_NOTIFICATIONS_AS_READ = gql`
  mutation markAllCrmNotificationsAsRead($relatedId: String!)
  @api(name: treatmentMonitor) {
    markAllCrmNotificationsAsRead(relatedId: $relatedId) {
      updatedCount
    }
  }
`;
